"use client";

import { useState, useCallback, useEffect } from "react";
import { Tab, Segment } from "semantic-ui-react";
import { CommentList } from "../../../common/index.js";
import { NewWcomment } from "../../../components/index.js";
import { sortbyoptions, sortbyeditoroptions } from "./SortByOptions.js";
import { getEditorPanes, getPanes, getReviewQuesPanes } from "./reviewPanes";
import {
  getAllquestions,
  addquestion,
} from "../../../modules/Graphql/questionandanswergraphql.js";
import {
  addquestionandreplies,
  helpanswer,
} from "../../../modules/Graphql/questionandrepliesgraphql.js";
import {
  getAllneighborhoodreview,
  helpreview,
  editorrate,
  editreview,
  deleteneighborhoodreview,
} from "../../../modules/Graphql/neighborhoodreviewgraphql.js";
import {
  sendNotification,
  sendQuestionNotification,
} from "../../../modules/Graphql/notificationgraphql.js";
import { getAllUserList } from "../../../modules/Graphql/usergraphql.js";
import { customencodeURIComponent, customdecodeURIComponent } from "../../../common/Utils/index.js";
import { fetchUserAttributes } from "aws-amplify/auth";
import EditReviewModal from "./EditReviewModal";
import ReviewWarningModal from "./ReviewWarningModal";
import SuccessModal from "./SuccessModal";
import { customStyles, customStylesReview } from "./modalStyles";
import { editorData } from "./data.json";

/**
 * Client-side component with interactive tabs and full functionality
 * Includes all features from NeighborhoodComponent.js
 */
export default function ReviewSectionClient({
  staticFirstTabContent,
  allReviews: initialReviews = [],
  questions: initialQuestions = [],
  nhdetails = [],
  neighborhoodId = "",
}) {
  // Tab and UI state
  const [activeIndex, setActiveIndex] = useState(0);
  const [sortby, setSortby] = useState("helpfulCount");
  
  // Reply and interaction states
  const [reply, setReply] = useState({});
  const [ques, setQues] = useState(false);
  const [comment, setComment] = useState({});
  const [like, setLike] = useState({});
  const [qlike, setQlike] = useState({});
  const [rlike, setRlike] = useState({});
  const [replies, setReplies] = useState({});
  const [askque, setAskque] = useState(false);
  const [onquestion, setOnquestion] = useState("");
  const [onreply, setOnreply] = useState("");
  const [values, setValues] = useState({});
  const [data, setData] = useState({});
  const [revs, setRevs] = useState(false);
  
  // Data states
  const [allReviews, setAllReviews] = useState(initialReviews);
  const [questions, setQuestions] = useState(initialQuestions);
  
  // User states
  const [userId, setUserId] = useState("");
  const [loggedin, setLoggedin] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [userImage, setUserImage] = useState("");
  const [realEstateFirm, setRealEstateFirm] = useState("");
  
  // Editor states
  const [isEditor, setIsEditor] = useState(false);
  const [showeditbutton, setShoweditbutton] = useState(false);
  
  // Modal states
  const [modaleditreviewIsopen, setModaleditreviewIsopen] = useState(false);
  const [isratemodalopen, setIsratemodalopen] = useState(false);
  const [ismodalopen, setIsmodalopen] = useState(false);
  
  // Review edit states
  const [editreviewdata, setEditreviewdata] = useState("");
  const [valueclub, setValueclub] = useState(0);
  const [valuequality, setValuequality] = useState(0);
  const [publicrate_err, setPublicrate_err] = useState(false);
  const [curbrate_err, setCurbrate_err] = useState(false);
  const [keywordfirst, setKeywordfirst] = useState("");
  const [keywordsec, setKeywordsec] = useState("");
  const [keywordthird, setKeywordthird] = useState("");
  const [description_err_status, setDescription_err_status] = useState(false);
  const [description_err_msg, setDescription_err_msg] = useState("");

  // Separate reviews by type
  const houseberrytakereview = allReviews.filter(
    (r) => r.editor_rate === 10 || r.editor_rate === "10"
  );
  const nhreviews = allReviews.filter(
    (r) => r.editor_rate > 0 && r.editor_rate != 10
  );
  const pendingreview = isEditor
    ? allReviews.filter((r) => r.editor_rate == 0)
    : [];
  const houseberrypickreview = allReviews.filter((r) => r.editor_rate > 3);

  const allcount = nhreviews.length;
  const pendingcount = pendingreview.length;
  const houseberrycount = houseberrypickreview.length;
  const is_display_review_txt = allcount === 0;
  const is_change_review_txt = allcount > 0;

  // Check authentication on mount
  useEffect(() => {
    checkAuthentication();
    
    // Check for success modal
    const isfromreview = localStorage.getItem("isfromnhreview");
    if (isfromreview === "Yes") {
      setIsmodalopen(true);
      localStorage.removeItem("isfromnhreview");
    }
  }, []);

  // Fetch user data when authenticated
  useEffect(() => {
    if (loggedin && userEmail) {
      fetchUserData();
    }
  }, [loggedin, userEmail]);

  // Update review edit data when houseberry take changes
  useEffect(() => {
    if (houseberrytakereview && houseberrytakereview.length > 0) {
      setValuequality(houseberrytakereview[0].curbAppealRating || 0);
      setValueclub(houseberrytakereview[0].publicSpacesRating || 0);
      setEditreviewdata(
        customdecodeURIComponent(houseberrytakereview[0].description) || ""
      );
    }
  }, [houseberrytakereview]);

  const checkAuthentication = async () => {
    try {
      const attributes = await fetchUserAttributes();
      
      if (attributes.email_verified === "true" || attributes.email_verified === true) {
        setLoggedin(true);
        setUserEmail(attributes.email);
        
        // Check if user is editor
        if (editorData.includes(attributes.email)) {
          setIsEditor(true);
          setShoweditbutton(true);
        }
      }
    } catch (err) {
      console.log("User not authenticated", err);
      setLoggedin(false);
    }
  };

  const fetchUserData = async () => {
    const getdata = {
      start: 0,
      limit: 10,
      orderBy: "email",
      order: "ASC",
      fields: [{ name: "email", value: userEmail, operator: "=" }],
    };

    try {
      const result = await getAllUserList(getdata);
      if (result.data.getUser && result.data.getUser.length > 0) {
        const user = result.data.getUser[0];
        setUserInfo(user);
        setUserId(user.id);
        setUserImage(user.userimage || "");
        setRealEstateFirm(user.realEstateFirm || "");
        
        if (typeof window !== "undefined") {
          localStorage.setItem("userId", user.id);
        }
        
        // Refetch reviews with user context
        getNhReviews(sortby);
        getQuestionandanswers();
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getNhReviews = useCallback(
    async (sortValue) => {
      const getdata = {
        start: 0,
        limit: 100,
        order: "DESC",
        orderBy: sortValue,
        fields: [
          { name: "NeighborhoodID", value: neighborhoodId, operator: "=" },
        ],
        auth_userId: userId,
      };

      try {
        const result = await getAllneighborhoodreview(getdata);
        if (result?.data?.getneighborhoodreview) {
          setAllReviews(result.data.getneighborhoodreview);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    },
    [neighborhoodId, userId]
  );

  const getQuestionandanswers = useCallback(async () => {
    const auth_userId =
      typeof window !== "undefined"
        ? localStorage.getItem("userId") || userId
        : userId;

    const getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "updatedDate",
      fields: [
        { name: "neighborhoodId", value: neighborhoodId, operator: "=" },
      ],
      auth_userId: auth_userId,
    };

    try {
      const result = await getAllquestions(getdata);
      if (result?.data?.getquestions) {
        setQuestions(result.data.getquestions);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  }, [neighborhoodId, userId]);

  // Notification functions
  const sendNotificationFunc = useCallback(
    async (subject, message, questionid) => {
      const noti_data = {
        subject: subject,
        message: message,
        userId: userId,
        neighborhoodId: neighborhoodId,
        questionid: questionid,
      };

      try {
        await sendNotification(noti_data);
      } catch (error) {
        console.error("Error sending notification:", error);
      }
    },
    [userId, neighborhoodId]
  );

  const sendQuestionNotificationFunc = useCallback(
    async (subject, message) => {
      const noti_data = {
        subject: subject,
        message: message,
        userId: userId,
        neighborhoodId: neighborhoodId,
      };

      try {
        await sendQuestionNotification(noti_data);
      } catch (error) {
        console.error("Error sending question notification:", error);
      }
    },
    [userId, neighborhoodId]
  );

  const sendeditorNotificationFunc = useCallback(
    async (subject, message, questionid) => {
      let editor_emails = editorData.toString();

      const noti_data = {
        subject: subject,
        message: message,
        userId: editor_emails,
        neighborhoodId: neighborhoodId,
        questionid: questionid,
      };

      try {
        await sendNotification(noti_data);
      } catch (error) {
        console.error("Error sending editor notification:", error);
      }
    },
    [neighborhoodId]
  );

  // Handler implementations
  const handleTabChange = useCallback((_e, { activeIndex: newIndex }) => {
    setActiveIndex(newIndex);
  }, []);

  const handlesortby = useCallback(
    (_e, data) => {
      setSortby(data.value);
      getNhReviews(data.value);
    },
    [getNhReviews]
  );

  const onShow = useCallback((index) => {
    setData((prev) => ({ ...prev, [index]: !prev[index] }));
  }, []);

  const onReviews = useCallback(() => {
    setRevs((prev) => !prev);
  }, []);

  const onComment = useCallback(
    (index) => {
      if (loggedin) {
        setComment((prev) => ({ ...prev, [index]: !prev[index] }));
      } else {
        if (typeof window !== "undefined") {
          localStorage.setItem("previous_url", window.location.href);
          document.getElementById("sign_up_btn")?.click();
        }
      }
    },
    [loggedin]
  );

  const askQues = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "onquestion") {
      setOnquestion(value);
    } else if (name === "onreply") {
      setOnreply(value);
    }
  }, []);

  const askreply = useCallback((e, index) => {
    setValues((prev) => ({ ...prev, [index]: e.target.value }));
    setOnreply(e.target.value);
  }, []);

  const onLike = useCallback(
    (index, e, data, queid, rlike_queid_qc_index, answerId, grid) => {
      if (loggedin) {
        let name = e?.target?.name || "desc";

        if (name === "desc" && data.UserID === userId) {
          setIsratemodalopen(true);
        } else if (name === "desc" && data.UserID != userId) {
          // Update review helpful count locally
          const updatedReviews = [...allReviews];
          const reviewIndex = updatedReviews.findIndex((r) => r.id === data.id);
          
          if (reviewIndex !== -1) {
            if (updatedReviews[reviewIndex].helpedUserId === "1") {
              updatedReviews[reviewIndex].helpfulCount = data.helpfulCount - 1;
              updatedReviews[reviewIndex].helpedUserId = "0";
            } else {
              updatedReviews[reviewIndex].helpfulCount = data.helpfulCount + 1;
              updatedReviews[reviewIndex].helpedUserId = "1";
            }
            setAllReviews(updatedReviews);
          }

          setLike((prev) => ({ ...prev, [index]: !prev[index] }));

          const adddata = {
            reviewId: data.id,
            neighborhoodId: data.NeighborhoodID,
            userId: userId,
            helpStatus: 1,
            helpedDate: new Date(),
            updatedDate: new Date(),
            reviewuserId: data.UserID,
          };

          helpreview(adddata)
            .then(() => {
              getNhReviews(sortby);
            })
            .catch((error) => console.error(error));
        } else if (name === "ques") {
          setQlike((prev) => ({ ...prev, [index]: !prev[index] }));
        } else if (name === "rply") {
          // Update answer helpful count locally
          const updatedQuestions = [...questions];
          const questionIndex = updatedQuestions.findIndex((q) => q.id === queid);
          
          if (questionIndex !== -1) {
            const replyIndex = updatedQuestions[questionIndex].replies.findIndex(
              (r) => r.id === data.id
            );
            
            if (replyIndex !== -1) {
              const reply = updatedQuestions[questionIndex].replies[replyIndex];
              if (reply.helpedUserId === "1") {
                reply.helpfulCount = data.helpfulCount - 1;
                reply.helpedUserId = "0";
              } else {
                reply.helpfulCount = data.helpfulCount + 1;
                reply.helpedUserId = "1";
              }
              setQuestions(updatedQuestions);
            }
          }

          setRlike((prev) => ({ ...prev, [index]: !prev[index] }));

          const adddata = {
            questionId: queid,
            answerId: answerId,
            userId: userId,
            helpContent: 1,
            helpStatus: 1,
            neighborhoodId: neighborhoodId,
            helpedDate: new Date(),
            updatedDate: new Date(),
            reviewuserId: data.replyuserid,
          };

          helpanswer(adddata).catch((error) => console.error(error));
        }
      } else {
        if (typeof window !== "undefined") {
          localStorage.setItem("previous_url", window.location.href);
          document.getElementById("sign_up_btn")?.click();
        }
      }
    },
    [loggedin, userId, neighborhoodId, sortby, allReviews, questions, getNhReviews]
  );

  const onEditorreview = useCallback(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("nhdetails", JSON.stringify(nhdetails));
      localStorage.setItem("neighborhoodId", neighborhoodId);
      localStorage.setItem("isfromnhreview", "Yes");
      window.location.href = "/NHReview?role=editor";
    }
  }, [nhdetails, neighborhoodId]);

  const onReview = useCallback(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("nhdetails", JSON.stringify(nhdetails));
      localStorage.setItem("neighborhoodId", neighborhoodId);
      
      if (loggedin) {
        localStorage.removeItem("saveR");
        window.location.href = "/NHReview";
      } else {
        localStorage.setItem("previous_url", window.location.href);
        // Will trigger signup modal
      }
    }
  }, [loggedin, nhdetails, neighborhoodId]);

  const onRate = useCallback(
    (index, e, grid, reviewid) => {
      const adddata = {
        editor_rate: e.target.textContent,
        reviewId: reviewid,
        neighborhoodId: neighborhoodId,
      };

      editorrate(adddata)
        .then(() => {
          getNhReviews(sortby);
        })
        .catch((error) => console.error(error));
    },
    [neighborhoodId, sortby, getNhReviews]
  );

  const onEditreview = useCallback(() => {
    setModaleditreviewIsopen(true);
  }, []);

  const onDeletereview = useCallback(async () => {
    if (houseberrytakereview.length === 0) return;

    const reviewid = houseberrytakereview[0].id;
    const deletedata = {
      id: reviewid,
      neighborhoodid: neighborhoodId,
    };

    try {
      await deleteneighborhoodreview(deletedata);
      getNhReviews(sortby);
      setModaleditreviewIsopen(false);
    } catch (error) {
      console.error("Error deleting review:", error);
    }
  }, [houseberrytakereview, neighborhoodId, sortby, getNhReviews]);

  const EditreviewFormSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      
      const reviewTxt = editreviewdata;
      let flag = 1;

      if (valueclub === 0) {
        flag = 0;
        setPublicrate_err(true);
      }
      if (valuequality === 0) {
        flag = 0;
        setCurbrate_err(true);
      }
      if (reviewTxt === "") {
        flag = 0;
        setDescription_err_status(true);
        setDescription_err_msg(
          "Please enter your review (Maximum 5000 characters are required)."
        );
      }
      if (reviewTxt && reviewTxt.length > 4998) {
        flag = 0;
        setDescription_err_status(true);
        setDescription_err_msg(
          `You entered ${reviewTxt.length} characters. Maximum 5000 characters are allowed.`
        );
      }

      if (flag === 1) {
        let keywords = "";
        if (keywordfirst || keywordsec || keywordthird) {
          keywords = `${keywordfirst},${keywordsec},${keywordthird}`;
        }

        const adddata = {
          description: customencodeURIComponent(reviewTxt),
          reviewId: houseberrytakereview[0].id,
          neighborhoodId: neighborhoodId,
          keywords: keywords,
          publicSpacesRating: valueclub || 0,
          curbAppealRating: valuequality || 0,
        };

        try {
          await editreview(adddata);
          getNhReviews(sortby);
          setModaleditreviewIsopen(false);
        } catch (error) {
          console.error("Error editing review:", error);
        }
      }
    },
    [
      editreviewdata,
      valueclub,
      valuequality,
      keywordfirst,
      keywordsec,
      keywordthird,
      houseberrytakereview,
      neighborhoodId,
      sortby,
      getNhReviews,
    ]
  );

  const reviewChange = useCallback((e) => {
    setEditreviewdata(e.target.value);
    setDescription_err_status(false);
  }, []);

  const handleChangeclub = useCallback((value) => {
    setValueclub(value);
    setPublicrate_err(value === 0);
  }, []);

  const handleChangequality = useCallback((value) => {
    setValuequality(value);
    setCurbrate_err(value === 0);
  }, []);

  const handlekeywordfirstChange = useCallback((e) => {
    setKeywordfirst(e.target.value);
  }, []);

  const handlekeywordsecChange = useCallback((e) => {
    setKeywordsec(e.target.value);
  }, []);

  const handlekeywordthirdChange = useCallback((e) => {
    setKeywordthird(e.target.value);
  }, []);

  const onReply = useCallback((index, id) => {
    setAskque(false);
    setReply((prev) => {
      const newReply = {};
      Object.keys(prev).forEach((v) => (newReply[v] = false));
      newReply[id] = !prev[id];
      return newReply;
    });
  }, []);

  const onQuestions = useCallback(() => {
    setQues((prev) => !prev);
  }, []);

  const onReplies = useCallback((e, index) => {
    setReplies((prev) => ({ ...prev, [index]: !prev[index] }));
  }, []);

  const onReplySubmit = useCallback(
    async (e) => {
      const adddata = {
        questionId: e,
        userId: userId,
        neighborhoodId: neighborhoodId,
        message: customencodeURIComponent(onreply),
        postedDate: new Date(),
        updatedDate: new Date(),
      };

      try {
        const result = await addquestionandreplies(adddata);
        if (result?.data?.createquestion_answer?.success) {
          // Send notifications
          const nhlink = `${window.location.protocol}//${window.location.host}/Neighborhood/${nhdetails[0]?.nhfullname}`;
          const subject = "A new Reply is Posted";
          const message = `A new Reply for a question is posted in Neighborhood <a target="_blank" href="${nhlink}">${nhdetails[0]?.label}</a>`;
          
          sendNotificationFunc(subject, message, e);
          
          // Refetch questions
          await getQuestionandanswers();
        }
        setOnreply("");
        setReply((prev) => ({ ...prev, [e]: !prev[e] }));
      } catch (error) {
        console.error("Error submitting reply:", error);
      }
    },
    [userId, neighborhoodId, onreply, nhdetails, sendNotificationFunc, getQuestionandanswers]
  );

  const askquestion = useCallback(() => {
    setReply((prev) => {
      const newReply = {};
      Object.keys(prev).forEach((v) => (newReply[v] = false));
      return newReply;
    });
    setAskque((prev) => !prev);
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      if (loggedin) {
        setAskque(false);
        const adddata = {
          userId: userId,
          neighborhoodId: neighborhoodId,
          question: customencodeURIComponent(onquestion),
          postedDate: new Date(),
          updatedDate: new Date(),
          lastUpdated: new Date(),
        };

        try {
          const result = await addquestion(adddata);
          if (result?.data?.createquestion?.success) {
            // Send notifications
            const nhlink = `${window.location.protocol}//${window.location.host}/Neighborhood/${nhdetails[0]?.nhfullname}`;
            const subject = "A new Question is Posted";
            const message = `A new Question was just asked in your saved neighborhood of <a target="_blank" href="${nhlink}">${nhdetails[0]?.label}</a>`;
            const editormsg = `A new Question is posted in neighborhood <a href="${nhlink}" target="_blank">${nhdetails[0]?.label}</a>`;

            sendNotificationFunc(subject, message, "");
            setTimeout(() => {
              sendQuestionNotificationFunc(subject, "A new Question is posted in Neighborhood in which you answered a question");
              sendeditorNotificationFunc(subject, editormsg, "editor");
            }, 500);

            // Refetch questions
            await getQuestionandanswers();
          }
          setOnquestion("");
        } catch (error) {
          console.error("Error submitting question:", error);
        }
      } else {
        if (typeof window !== "undefined") {
          const quesData = {
            neighborhoodId: neighborhoodId,
            question: customencodeURIComponent(onquestion),
            nhfullname: nhdetails[0]?.nhfullname,
            label: nhdetails[0]?.label,
          };
          localStorage.setItem("quesData", JSON.stringify(quesData));
          localStorage.setItem("isfromques", "Yes");
          localStorage.setItem("previous_url", window.location.href);
          document.getElementById("sign_up_btn")?.click();
        }
      }
    },
    [
      loggedin,
      userId,
      neighborhoodId,
      onquestion,
      nhdetails,
      sendNotificationFunc,
      sendQuestionNotificationFunc,
      sendeditorNotificationFunc,
      getQuestionandanswers,
    ]
  );

  const handlecloseisratemodal = useCallback(() => {
    setIsratemodalopen(false);
  }, []);

  const closeeditreviewmodal = useCallback(() => {
    setModaleditreviewIsopen(false);
  }, []);

  const closeModalsucess = useCallback(() => {
    setIsmodalopen(false);
  }, []);

  // Handlers object
  const handlers = {
    handlesortby,
    onShow,
    onReviews,
    onComment,
    askQues,
    onLike,
    onEditorreview,
    onReview,
    onRate,
    onEditreview,
    onDeletereview,
    onReply,
    onQuestions,
    onReplies,
    askreply,
    onReplySubmit,
    askquestion,
    onSubmit,
  };

  // State object matching NeighborhoodComponent structure
  const state = {
    houseberrytakereview,
    nhreviews,
    pendingreview,
    allcount,
    pendingcount,
    houseberrycount,
    questions,
    nhdetails,
    userId,
    is_editor: isEditor,
    showeditbutton: showeditbutton,
    user_info: userInfo ? [userInfo] : [],
    is_display_review_txt,
    is_change_review_txt,
    values,
  };

  // Create panes using getReviewQuesPanes (matches NeighborhoodComponent)
  const panes = getReviewQuesPanes(
    state,
    handlers,
    data,
    revs,
    comment,
    like,
    reply,
    ques,
    qlike,
    rlike,
    replies,
    askque,
    onquestion,
    sortbyoptions,
    sortbyeditoroptions
  );

  return (
    <>
      <Tab
        menu={{ text: true, attached: "bottom" }}
        panes={panes}
        className="review_tab_inner nh_tab"
        style={{ border: 0 }}
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      />

      {/* Modals */}
      {isratemodalopen && (
        <ReviewWarningModal
          isModalOpen={isratemodalopen}
          style={customStyles}
          contentLabel="Rate Modal"
          onClickClose={handlecloseisratemodal}
        />
      )}

      {modaleditreviewIsopen && (
        <EditReviewModal
          modaleditreviewIsopen={modaleditreviewIsopen}
          closeeditreviewmodal={closeeditreviewmodal}
          customStyles={customStyles}
          valueclub={valueclub}
          handleChangeclub={handleChangeclub}
          publicrate_err={publicrate_err}
          valuequality={valuequality}
          handleChangequality={handleChangequality}
          curbrate_err={curbrate_err}
          keywordfirst={keywordfirst}
          handlekeywordfirstChange={handlekeywordfirstChange}
          keywordsec={keywordsec}
          handlekeywordsecChange={handlekeywordsecChange}
          keywordthird={keywordthird}
          handlekeywordthirdChange={handlekeywordthirdChange}
          houseberrytakereview={houseberrytakereview}
          reviewChange={reviewChange}
          description_err_status={description_err_status}
          description_err_msg={description_err_msg}
          EditreviewFormSubmit={EditreviewFormSubmit}
        />
      )}

      {ismodalopen && (
        <SuccessModal
          ismodalopen={ismodalopen}
          closeModalsucess={closeModalsucess}
          customStylesReview={customStylesReview}
        />
      )}
    </>
  );
}
